import { Locale } from 'antd/es/locale';
import enUS from 'antd/lib/locale/en_US';
import trTR from 'antd/lib/locale/tr_TR';
import { Languages } from '../model/types';

const getAntdLocaleConfig = (locale: string): Locale => {
    if (locale === Languages.TR) return trTR;
    if (locale === Languages.EN) return enUS;

    return null;
};

export default getAntdLocaleConfig;
